import React from 'react';
import AdminLayout from '../components/AdminLayout';

const AdminDashboard = () => {
  return (
    <AdminLayout />
  );
};

export default AdminDashboard;
